module.exports = __webpack_public_path__ + "img/Joel.a8577f32.png";